if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.stickyButton = this.querySelector('.sticky-add-to-cart__button');
        this.stickyPrice = this.querySelector('.sticky-add-to-cart__price');
        this.originalBuyButton = null;
        this.observer = null;
      }

      connectedCallback() {
        this.originalBuyButton = document.querySelector(
          `#ProductSubmitButton-${this.sectionId}`
        );

        if (!this.originalBuyButton) return;

        // Observe when the original Add to Cart button leaves/enters viewport
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('is-visible', !entry.isIntersecting);
            });
          },
          { threshold: 0, rootMargin: '0px' }
        );

        this.observer.observe(this.originalBuyButton);

        // Clicking the sticky button triggers the original form submit
        this.stickyButton.addEventListener('click', this.onStickyClick.bind(this));

        // Listen for variant changes to update price and availability
        document.addEventListener('variant:change', this.onVariantChange.bind(this));

        // Also listen for the theme's native variant change event on product-info
        this.listenForVariantUpdates();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      onStickyClick() {
        if (this.stickyButton.disabled || this.stickyButton.getAttribute('aria-disabled') === 'true') return;

        const originalForm = document.querySelector(`#ProductFormInstallment-${this.sectionId}`) ||
          document.querySelector(`[data-section="${this.sectionId}"] product-form form`);

        if (originalForm) {
          // Trigger the original form's submit button
          const submitBtn = originalForm.querySelector('[type="submit"]');
          if (submitBtn) {
            submitBtn.click();
            return;
          }
        }

        // Fallback: click the original button directly
        if (this.originalBuyButton) {
          this.originalBuyButton.click();
        }
      }

      listenForVariantUpdates() {
        // Monitor for price/availability changes in the product info section
        const priceContainer = document.querySelector(`#price-${this.sectionId}`);
        if (priceContainer) {
          const priceObserver = new MutationObserver(() => {
            this.updatePriceFromDOM();
          });
          priceObserver.observe(priceContainer, { childList: true, subtree: true, characterData: true });
        }

        // Monitor the original submit button for disabled state changes
        if (this.originalBuyButton) {
          const buttonObserver = new MutationObserver(() => {
            this.syncButtonState();
          });
          buttonObserver.observe(this.originalBuyButton, { attributes: true, childList: true, subtree: true });
        }
      }

      updatePriceFromDOM() {
        const priceContainer = document.querySelector(`#price-${this.sectionId} .price-item--regular`);
        if (priceContainer && this.stickyPrice) {
          this.stickyPrice.textContent = priceContainer.textContent.trim();
        }
      }

      syncButtonState() {
        if (!this.originalBuyButton || !this.stickyButton) return;

        const isDisabled = this.originalBuyButton.disabled ||
          this.originalBuyButton.getAttribute('aria-disabled') === 'true';
        this.stickyButton.disabled = isDisabled;

        // Sync the button text
        const originalSpan = this.originalBuyButton.querySelector('span');
        const stickySpan = this.stickyButton.querySelector('span');
        if (originalSpan && stickySpan) {
          stickySpan.textContent = originalSpan.textContent;
        }
      }

      onVariantChange(event) {
        if (event.detail && event.detail.sectionId === this.sectionId) {
          this.syncButtonState();
          this.updatePriceFromDOM();
        }
      }
    }
  );
}
